import { render, staticRenderFns } from "./43_mv_tipo_figura.vue?vue&type=template&id=e82ecec0&scoped=true&"
import script from "./43_mv_tipo_figura.vue?vue&type=script&lang=js&"
export * from "./43_mv_tipo_figura.vue?vue&type=script&lang=js&"
import style0 from "./43_mv_tipo_figura.vue?vue&type=style&index=0&id=e82ecec0&scoped=true&lang=css&"
import style1 from "./43_mv_tipo_figura.vue?vue&type=style&index=1&id=e82ecec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ecec0",
  null
  
)

export default component.exports